export default __webpack_public_path__ + "static/media/petro.c0cdf9b0.jpg";